interface RgbChannels {
  r: number,
  g: number,
  b: number,
}

export const getAverageRgb = async (base64image: string): Promise<RgbChannels> => {
  return new Promise((resolve, reject) => {
    const defaultRGB:RgbChannels = {r:0,g:0,b:0};
    const blockSize = 5;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext && canvas.getContext('2d');
    if (!context) {
      reject(defaultRGB);
      return;
    }
    const hiddenImage = document.createElement('img');
    hiddenImage.setAttribute('src', base64image);
    hiddenImage.onload = (_) => {
      var rgb: RgbChannels = defaultRGB;
      var data: any;
      var i = -4;
      var length;
      var count = 0;
      var height = canvas.height = hiddenImage.naturalHeight || hiddenImage.offsetHeight || hiddenImage.height;
      var width = canvas.width = hiddenImage.naturalWidth || hiddenImage.offsetWidth || hiddenImage.width;
    
      context.drawImage(hiddenImage, 0, 0);
    
      try {
        data = context.getImageData(0, 0, width, height);
      } catch(e) {
        reject(defaultRGB);
        return;
      }
    
      length = data.data.length;
    
      while ( (i += blockSize * 4) < length ) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i+1];
        rgb.b += data.data[i+2];
      }
    
      // ~~ used to floor values
      rgb.r = ~~(rgb.r/count);
      rgb.g = ~~(rgb.g/count);
      rgb.b = ~~(rgb.b/count);
    
      resolve(rgb);
      return;
    }
  })
}